import { useContext, useEffect } from "react";
import { Context } from "./index";

const HOTSPOT_TYPE = {
  WALK_WAY: 1,
  INFO: 2,
  VOICE_MEMO: 3,
  PICTURE: 4,
};

var musicPlayer;

const ToolTipInfo = () => {
  const { tooltipInfo, closeOverlay } = useContext(Context);

  const { title, desc, type, file } = tooltipInfo;

  useEffect(() => {
    if (type === HOTSPOT_TYPE.VOICE_MEMO) {
      musicPlayer = new Audio(URL.createObjectURL(file));
      musicPlayer.play();
    }

    return () => {
      if (type === HOTSPOT_TYPE.VOICE_MEMO) musicPlayer?.pause();
    };
  }, []);

  const handleCloseClick = () => {
    if (type === HOTSPOT_TYPE.VOICE_MEMO && musicPlayer?.played)
      musicPlayer?.pause();

    closeOverlay();
  };

  return (
    <div className="pannellum-hotspot-tooltip">
      <div className="pannellum-hotspot-tooltip-container">
        <div className="pannellum-hotspot-tooltip-container-header">
          <h2 className="pannellum-hotspot-tooltip-container-header__title">
            {title}
          </h2>
          <div
            className="pannellum-hotspot-tooltip-container-header__close"
            onClick={handleCloseClick}
          >
            Close
          </div>
        </div>
        <div className="pannellum-hotspot-tooltip-container-content">
          {desc && (
            <p className="pannellum-hotspot-tooltip-container-content__desc">
              {desc}
            </p>
          )}
          {type === HOTSPOT_TYPE.PICTURE && file && (
            <img
              className="pannellum-hotspot-tooltip-container-content__image"
              alt=""
              src={URL.createObjectURL(file)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ToolTipInfo;
